var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "select",
    {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.valueData,
          expression: "valueData"
        }
      ],
      staticClass: "form-control",
      class: { "is-invalid": _vm.layoutData.errorText != null },
      staticStyle: { width: "initial" },
      on: {
        change: [
          function($event) {
            var $$selectedVal = Array.prototype.filter
              .call($event.target.options, function(o) {
                return o.selected
              })
              .map(function(o) {
                var val = "_value" in o ? o._value : o.value
                return val
              })
            _vm.valueData = $event.target.multiple
              ? $$selectedVal
              : $$selectedVal[0]
          },
          _vm.onChange
        ]
      }
    },
    _vm._l(_vm.options, function(option, index) {
      return _c("option", { key: index, domProps: { value: option.value } }, [
        _vm._v(_vm._s(option.label))
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }